<ng-container *ngIf="type == 'Multi'">
  <!-- <h4>{{ acc.title }}</h4> -->
  <!-- {{ data['id'] | json }} -->
  <div class="adc-acrdn" *ngFor="let acc of data">
    <div ngClass="{{ data.customClass }}">
      <h2 class="adc-acrdn-head">
        <button type="button" (click)="toggle(acc.id)">
            <!-- <mat-icon *ngIf="!this.show.includes(acc.id)" class="adc-size-10">arrow_right</mat-icon> -->
            <span class="material-symbols-outlined" *ngIf="!this.show.includes(acc.id)">keyboard_arrow_right</span>
            <span class="material-symbols-outlined" *ngIf="this.show.includes(acc.id)">keyboard_arrow_down</span>
            <!-- <svg xmlns="http://www.w3.org/2000/svg" *ngIf="!this.show.includes(acc.id)" viewBox="0 0 24 24" width="15px"><title>menu-right</title><path d="M10,17L15,12L10,7V17Z" /></svg> -->
            <!-- <svg xmlns="http://www.w3.org/2000/svg" *ngIf="this.show.includes(acc.id)" viewBox="0 0 24 24" width="15px"><title>menu-down</title><path d="M7,10L12,15L17,10H7Z" /></svg> -->
            <!-- <mat-icon *ngIf="this.show.includes(acc.id)" class="adc-size-10">arrow_drop_down</mat-icon> -->
            <span>{{ acc.title }}</span>
        </button>
      </h2>
      <div class="adc-acrdn-body" *ngIf="this.show.includes(acc.id)">
        {{ acc.content }}
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="type == 'single'">
  <div class="adc-acrdn">
    <div ngClass="{{ data[0].customClass }}">
      <h2 class="adc-acrdn-head">
        <button type="button" (click)="toggle(data[0].id)">
            <!-- <mat-icon *ngIf="!show.includes(data[0].id)" class="adc-size-10">arrow_right</mat-icon>
            <mat-icon *ngIf="show.includes(data[0].id)" class="adc-size-10">arrow_drop_down</mat-icon> -->
            <span class="material-symbols-outlined" *ngIf="!this.show.includes(data[0].id)">keyboard_arrow_right</span>
            <span class="material-symbols-outlined" *ngIf="this.show.includes(data[0].id)">keyboard_arrow_down</span>
            <!-- <svg xmlns="http://www.w3.org/2000/svg" *ngIf="!show.includes(data[0].id)" viewBox="0 0 24 24" width="15px"><title>menu-right</title><path d="M10,17L15,12L10,7V17Z" /></svg>
            <svg xmlns="http://www.w3.org/2000/svg" *ngIf="show.includes(data[0].id)" viewBox="0 0 24 24" width="15px"><title>menu-down</title><path d="M7,10L12,15L17,10H7Z" /></svg> -->
            <!-- <img src="../../../../assets/Common Icons/chevron.svg" alt="" *ngIf="!show.includes(data[0].id)">
            <img src="../../../../assets/Common Icons/down-arrow.svg" alt="" *ngIf="show.includes(data[0].id)"> -->
            <span>{{ data[0].title }}</span>
        </button>
      </h2>
      <div class="adc-acrdn-body" *ngIf="this.show.includes(data[0].id) && !data[0].customHtml">
        {{ data[0].content }}
      </div>
      <div class="adc-acrdn-body" *ngIf="this.show.includes(data[0].id) && data[0].customHtml">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</ng-container>
